import React from 'react';
import styled from 'styled-components';
import Layout from '../components/layout';
import Accounts from '../components/accounts';
import { media } from '../components/helpers';

const AccountPageContainer = styled.div`
    /* padding-top: 108px; */
`;

const AccountPage = () => {
    return (
        <Layout>
            <AccountPageContainer>
                <Accounts />
            </AccountPageContainer>
        </Layout>
    );
};

export default AccountPage;
